import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Row, Col, DropdownItem, Label } from 'reactstrap';
import { MagstimTreatmentQualityChart, MagstimColor, MagstimDropdown, CurrentLang } from "common";


class MagstimFilteredTreatmentQualityChart extends React.Component {

    constructor() {
        super();
        this._chart = React.createRef();
        this._filter = React.createRef();

        this.state = {
            filterOptions: [],
            selectedFilter: "0",
            sumPulses:0,
            data:[]
        }
    }

    componentDidMount() {
        this._chart.current.init(12);
        this._chart.current.setDistance(0);
        this._chart.current.setContact(0);
        this._chart.current.setTilt(0);
        this._chart.current.setRotation(0);
    }

    onSelectFilter = (id) => {
        this.setState({ selectedFilter: id }, () => this.onFilterChanged())
    }

    onFilterChanged = () => {
        
        var selectedItem = this.state.data[this.state.selectedFilter];

        if(selectedItem !== null && selectedItem !== undefined){
            if(selectedItem.SumPulses > 0){
                this._chart.current.setDistance(100 * (selectedItem.SumPulsesWithinDistanceTolerance / selectedItem.SumPulses));
                this._chart.current.setContact(100 * (selectedItem.SumPulsesWithinContactTolerance / selectedItem.SumPulses));
                this._chart.current.setRotation(100 * (selectedItem.SumPulsesWithinRotationTolerance / selectedItem.SumPulses));
                this._chart.current.setTilt(100 * (selectedItem.SumPulsesWithinTiltTolerance / selectedItem.SumPulses));
            }
            else{
                this._chart.current.setDistance(0);
                this._chart.current.setContact(0);
                this._chart.current.setRotation(0);
                this._chart.current.setTilt(0);
            }
            this.setState({sumPulses: selectedItem.SumPulses});
        }
    }
    
    setAccuracyData(data) {

        // Update the UI based on the filter settings
        if (this._chart && this._chart.current) {

            // Create an object for the average of all data
            var overallAverage = {};
            overallAverage.title = this.props.allDataTitle;
            overallAverage.SumPulses = 0;
            overallAverage.SumPulsesWithinDistanceTolerance = 0;
            overallAverage.SumPulsesWithinContactTolerance = 0;
            overallAverage.SumPulsesWithinRotationTolerance = 0;
            overallAverage.SumPulsesWithinTiltTolerance = 0;

            var filteredAverages = [];

            data.forEach(item => {
                // Get the average of all options
                overallAverage.SumPulses += item.SumPulses;
                overallAverage.SumPulsesWithinDistanceTolerance += item.SumPulsesWithinDistanceTolerance;
                overallAverage.SumPulsesWithinContactTolerance += item.SumPulsesWithinContactTolerance;
                overallAverage.SumPulsesWithinRotationTolerance += item.SumPulsesWithinRotationTolerance;
                overallAverage.SumPulsesWithinTiltTolerance += item.SumPulsesWithinTiltTolerance;

                // Add the "average on" data, if the props are set averages to the list
                if(this.props.averageOnNameProperty.length > 0 && this.props.averageOnGuidProperty.length > 0  && this.props.averageOnTitle.length > 0){

                    const itemGuid = item[this.props.averageOnGuidProperty];

                    if(filteredAverages[itemGuid] === undefined){
                        // Create a new item for the optional averages
                        filteredAverages[itemGuid] = {};
                        filteredAverages[itemGuid].title = this.props.averageOnTitle + ' - ' + item[this.props.averageOnNameProperty];

                        filteredAverages[itemGuid].SumPulses = 0;
                        filteredAverages[itemGuid].SumPulsesWithinDistanceTolerance = 0;
                        filteredAverages[itemGuid].SumPulsesWithinContactTolerance = 0;
                        filteredAverages[itemGuid].SumPulsesWithinRotationTolerance = 0;
                        filteredAverages[itemGuid].SumPulsesWithinTiltTolerance = 0;
                    }
    
                    filteredAverages[itemGuid].SumPulses += item.SumPulses;
                    filteredAverages[itemGuid].SumPulsesWithinDistanceTolerance += item.SumPulsesWithinDistanceTolerance;
                    filteredAverages[itemGuid].SumPulsesWithinContactTolerance += item.SumPulsesWithinContactTolerance;
                    filteredAverages[itemGuid].SumPulsesWithinRotationTolerance += item.SumPulsesWithinRotationTolerance;
                    filteredAverages[itemGuid].SumPulsesWithinTiltTolerance += item.SumPulsesWithinTiltTolerance;
                }
            });
            
            // Add the all data average
            var allData = [];
            allData.push(overallAverage);

            // Add the "average on" 
            // eslint-disable-next-line no-unused-vars
            for (const [key, value] of Object.entries(filteredAverages)) {
                allData.push(value);
            }

            // Now add the actual  data passed in
            allData = allData.concat(data);

            // Combine into a list of all options 
            var filterOptions = [];

            allData.forEach(item => {
                if(item.title !== undefined){
                    filterOptions.push(item.title);
                }
                else{
                    filterOptions.push(this.props.filterTitle + ' - ' + item[this.props.filterOn]);
                }
            });

            this.setState({ filterOptions: filterOptions, data: allData }, () => this.onFilterChanged())
        }
    }

    render() {

        // Set all the layout elements as variable 
        let filterHeaderItems = [];

        filterHeaderItems = filterHeaderItems.concat(this.state.filterOptions.map((key, index) => (
            <DropdownItem id={String(index)}
                key={String(index)}
            > {this.state.filterOptions[index]}</DropdownItem>
        )));

        const header = <> <Row className="header">

            <Col className="mt-auto mb-auto">
                {<MagstimDropdown id="filterDropdown" ref={this._filter} onSelect={this.onSelectFilter} icon={this.props.filterIcon} dropDownKey={this.state.selectedFilter}>
                    {filterHeaderItems}
                </MagstimDropdown>}
            </Col>
        </Row>
        </>

        return (
            <Wrapper>
                {header}        
                <MagstimTreatmentQualityChart ref={this._chart} chartCanvasName={`filter-chart-${this.props.chartCanvasName}`} ></MagstimTreatmentQualityChart>
                <Row className="footer">
                    <Label className="ml-2 mr-2">{`${CurrentLang().history_details_burst_pulses} ${this.state.sumPulses}`}</Label>
                </Row>
            </Wrapper>
        );
    }
}

MagstimFilteredTreatmentQualityChart.propTypes = {
    allDataTitle: PropTypes.string,
    averageOnNameProperty:PropTypes.string,
    averageOnGuidProperty:PropTypes.string,
    averageOnTitle: PropTypes.string,
    filterOn: PropTypes.string,
    filterTitle: PropTypes.string,
    filterIcon:PropTypes.string
};

MagstimFilteredTreatmentQualityChart.defaultProps = {
    allDataTitle: CurrentLang().analytics_all_treaters,
    averageOnNameProperty:"ClinicName",
    averageOnGuidProperty:"ClinicGuid",
    averageOnTitle: CurrentLang().clinic,
    filterOn: "TreaterFullName",
    filterTitle: CurrentLang().treater,
    filterIcon:'fas fa-user'
};

const Wrapper = styled.div`

.header{
    color: ${ MagstimColor.MagstimGroupHeaderText };
    background-color: ${ MagstimColor.MagstimCardHeaderBackground };
    border-color: ${ MagstimColor.MagstimCardHeaderBackground };
    margin-left:0px;
    margin-right:0px;
}

.footer{
    color: ${ MagstimColor.MagstimTextForground };
    background-color: ${ MagstimColor.MagstimTextBackground };
    border-color: ${ MagstimColor.MagstimTextBackground };
    margin-left:0px;
    margin-right:0px;
    display:block;
    text-align: right;
}

`

export default MagstimFilteredTreatmentQualityChart;